import ArticleTemplate from './ArticleTemplate';
import { allArticles } from './data';
export default function Page() { return <ArticleTemplate article={allArticles[9]} />; }